document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.ProductTabs .SingleTab');

    if (tabs) {
        tabs.forEach((tab) => {
            const heading = tab.querySelector('.heading');
            heading.addEventListener('click', () => {
                const isActive = tab.classList.contains('active');

                // Usuwamy klasę 'active' ze wszystkich tabów
                tabs.forEach((t) => t.classList.remove('active'));

                // Jeśli kliknięty tab nie był aktywny, dodajemy klasę 'active'
                if (!isActive) {
                    tab.classList.add('active');
                }
            });
        });
    }
});


document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.CategoryTabs .SingleTab');

    if (tabs) {
        tabs.forEach((tab) => {
            const heading = tab.querySelector('.heading');
            heading.addEventListener('click', () => {
                const isActive = tab.classList.contains('active');

                // Usuwamy klasę 'active' ze wszystkich tabów
                tabs.forEach((t) => t.classList.remove('active'));

                // Jeśli kliknięty tab nie był aktywny, dodajemy klasę 'active'
                if (!isActive) {
                    tab.classList.add('active');
                }
            });
        });
    }
});
